/* eslint-disable require-jsdoc */
let counter = 0;
function defaultImg() {
  const index = counter % 17;
  counter += 1;
  return getRandomDefaultImg(index);
}

function getRandomDefaultImg(counter) {
  const defaultPictures = [
    `https://www.hearby.com/wp-content/uploads/2020/07/default1.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default2.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default3.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default4.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default5.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default6.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default7.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default8.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default9.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default10.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default11.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default12.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default13.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default14.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default15.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default16.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default17.jpg`,
    `https://www.hearby.com/wp-content/uploads/2020/07/default18.jpg`,
  ];
  return defaultPictures[counter];
}

export {defaultImg};
